import React from 'react';

import { useCreateLabel, useEditLabel, useLoadLabel } from 'scenes/Labels/data';

import LabelForm from './LabelForm';
import { NAME } from './constants';

export const CreateLabelForm = ({ onClose, onExited, open }) => {
  const [createCG, { isLoading: isCreating }] = useCreateLabel();

  const handleSubmit = async (values = {}) => {
    await createCG(values);
    onClose();
  };

  return (
    <LabelForm
      title={`Add Label`}
      loading={isCreating}
      initialValues={{}}
      onSubmit={handleSubmit}
      onClose={onClose}
      onExited={onExited}
      open={open}
    />
  );
};

export const EditLabelForm = ({ id, onClose, onExited, open }) => {
  const { data, isLoading } = useLoadLabel(id);
  const [updateCG, { isLoading: isUpdating }] = useEditLabel();

  const handleSubmit = async (values = {}) => {
    await updateCG(values);
    onClose();
  };

  return (
    <LabelForm
      title={`Edit Label`}
      subTitle={data?.[NAME]}
      entityId={id}
      loading={isLoading || isUpdating}
      initialValues={data}
      active={!!data}
      onSubmit={handleSubmit}
      onClose={onClose}
      onExited={onExited}
      open={open}
    />
  );
};
